// extracted by mini-css-extract-plugin
module.exports = {"item":"cd01fbf7b5--item--nU1cp","title":"cd01fbf7b5--title--ycvYq","content":"cd01fbf7b5--content--CaOFn","icon":"cd01fbf7b5--icon--oBh06"};